import { CLUB_STOCK_OUT_STATUS } from "@clubInventory/constants/dataEnums";

// 功能：出貨單狀態對應顏色（Chip）
export const statusColorByValue = {
	[CLUB_STOCK_OUT_STATUS.NORMAL]: "success",
	[CLUB_STOCK_OUT_STATUS.ERROR]: "error",
	[CLUB_STOCK_OUT_STATUS.ALL]: "gray",
    [CLUB_STOCK_OUT_STATUS.NONE]: "gray",
};
